import { modals } from "@mantine/modals";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { Box, Button, Group, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";

const DeleteItemNotes = ({
  listId,
  onSuccess,
}: {
  listId: number[];
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const handleDelete = async () => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<boolean>>(
        "/api/v1/TblDmItemNote/delete",
        listId,
      );
      if (res && res.success) {
        NotificationExtension.Success("Xóa ghi chú hàng hóa thành công !");
        setTimeout(() => {
          onSuccess(true);
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn xóa các ghi chú hàng hóa này ?
      </Text>
      <Group justify="center" mt={10}>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
          loading={visible}
          disabled={visible}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteItemNotes;
